import { PropsWithChildren, ReactNode } from "react";
import styles from "./Card.module.scss";
import Image from "next/image";

export const Card: React.FC<
  PropsWithChildren<{
    title: ReactNode;
    background?: string;
  }>
> = ({ title, children, background }) => {
  return (
    <div
      className={styles.root}
      style={{
        backgroundImage: background ? `url(${background})` : "none",
      }}
    >
      <h3>{title}</h3>
      <div>{children}</div>
    </div>
  );
};
